import {
  btnAddToCart,
  changeForFormatedTotalPrice,
  deleteItem,
  initInterceptionSufio,
  onChangeItemCart,
  openCloseCart,
} from '../components/cart';
import { setupCustomSelect } from '../components/custom-select';
import { initContactHeader, openContactMenu, openSide, toggleMenu } from '../components/header';
import initInstaFeedSlider from "../components/instafeed";
import { validateNewsLetter } from '../components/newsletter';
import { priceVat } from '../components/price-vat';
import { btnShowVariants } from '../components/product.modal';
import { openTabs } from '../components/tabs';
import initTopbarSlider from '../components/top-bar';
import { variantOnChange } from '../components/variants-product';
import { initVideoFrame } from '../components/video-frame';
import { openAccordion } from '../utils/accordion';
import { setQuantity } from '../utils/input-quantity';

import 'swiper/css';
import '../components/activate-customer_lang';
import "../components/backInStock";
import "../components/country-selector";
import '../components/create-customer_lang';
import '../components/get-best-sellers';
import '../components/my-account-lang_selector';
import "../components/predictive-search";
import { rewardPoints } from '../components/rewards-points';
import { initTrackingShipping } from "../components/shipping-tracker";
import '../components/slider-swiper';
import "../components/upsell-recommendations";
import { cartVATValidation, formVAT, vatInputValidation } from '../components/validateVat';
import { vipCart, vipLidocainValidation } from '../components/vip-section';
import '../scss/main.scss';
import { changeBadLogoImage } from '../utils/header-logo';
import { sufioFormManipulator } from '../utils/sufio-form';

openCloseCart();
variantOnChange('.variants');
rewardPoints();
openAccordion();
openTabs();
openSide();
toggleMenu();

initContactHeader(
  '.sidebar-menu__contact-content',
  openContactMenu('.sidebar-menu__contact-button', '.sidebar-menu__contact-content', 'click'),
);

initContactHeader(
  '.header__contact-details',
  openContactMenu('.header__contact', '.header__contact-details', 'mouseover'),
);

btnAddToCart('.add-product-cart');
btnAddToCart('.add-product-cart-upsell');
btnShowVariants('.btn-show-variants-js');
setupCustomSelect();
deleteItem();
setQuantity();
onChangeItemCart();
initInstaFeedSlider();
initVideoFrame();
validateNewsLetter();
initTopbarSlider();
priceVat();
formVAT();
cartVATValidation();
vatInputValidation();
vipCart();
vipLidocainValidation();
changeBadLogoImage()

//Verification to checkout
initTrackingShipping();

const centerBackInStock = () => {

  setTimeout(() => {
    const klaviyoTarget = document.querySelector(".klaviyo-bis-trigger");
    if (!klaviyoTarget) return;

    klaviyoTarget.addEventListener('click', () => {
      const iframe = document.querySelector("#klaviyo-bis-iframe");
    });
  }, 500);

};

const btnContact = document.querySelector('.btn-contact');

btnContact?.addEventListener('click', () => {
  window.scroll(0, 0);
})

changeForFormatedTotalPrice();
centerBackInStock();
initInterceptionSufio();
sufioFormManipulator();